import { uniqueKey } from "global/common/keys";
import { Form, Icon, Label } from "semantic-ui-react";
import _ from 'lodash'

export const dropDown_golfCourse = (golfCourse, currentGolfer, golferTeebox, handleGolfCourseTeeboxChange) => {

  const { name, _itemKey: key, teeBoxes } = golfCourse ?? {}
  const { courseHandicaps, courseTeeboxes } = currentGolfer ?? {}

  const courseHandicap = courseHandicaps?.[key]
  const courseTeebox = courseTeeboxes?.[key]

  const teeboxOptions = _.map(teeBoxes, (tb, tbk) => ({
    key: tbk,
    text: _.startCase(tbk),
    value: tbk
  }))

  const ddLabel = <div className={'golf-hcp-label'}>
    {'Course: ' + _.startCase(name)}
    <Label color={courseHandicap ? 'blue' : 'grey'}>
      <Icon name='golf ball' />{courseHandicap ? courseHandicap : '-'}
    </Label>
  </div>

  // const opts = getCourseTeeBoxesOptions(golfCourse)

  return <Form.Dropdown
    className='swiper-no-swiping'
    key={uniqueKey('gh', 'tb', golferTeebox)}
    gtb={golferTeebox}
    gck={key}
    label={ddLabel}
    selection
    fluid
    options={teeboxOptions}
    onChange={handleGolfCourseTeeboxChange}
    value={courseTeebox}
  />
}

``